RivalIQ.apps.Insights.module('widgets.media', function (media, App, Backbone, Marionette, $, _, s, moment) {

    'use strict';

    function makeOrderDetailsStr(orderDetails) {
        return [orderDetails.idx + 1, orderDetails.total].join(' of ');
    }

    const aggregatePaidToOrganicProperty = {
        'engagement_total': 'organic_engagement_total'
    };

    function formatStoryDate(date, timezone) {
        date = moment.utc(date);
        const tzPart = RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, date);
        const datePart = date.format('MMM D, YYYY');

        return `${datePart} ${tzPart}`;
    }

    function formatPublishedAt(date, timezone) {
        const dateInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, date);
        const datePart = dateInTz.format('MMM D, YYYY');
        const tzPart = RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, date);

        return `${datePart} ${tzPart}`;
    }

    const BaseGridItem = RivalIQ.views.SocialPostGridItem.extend({

        onAttach: function () {
            const me = this;

            // NOTE if the image fails to load then we must notify the grid
            // (which will remove the model from the collection entirely)
            me.ui.image.on('error', function (e) {

                me.onImageLoadError(e.currentTarget.src);
            });
            RivalIQ.apps.SocialPosts.utils.attachVideoOnLoadHandlers(me.$el);
        },

        ui: _.defaults({
            popover: `[data-toggle='popover']`
        }, RivalIQ.views.SocialPostGridItem.prototype.ui),

        getGridDetailMetric: function () {
            const me = this;

            const dashboardModel = me.dashboardModel;
            let orderByProperty = App.utils.getOrderBy(me);

            // NOTE if we are in "summary" view we need to adjust our `orderBy`
            // if the token does not have access to paid engagement
            if (!dashboardModel.isFocus() &&
                !App.utils.hasInstagramPaidEngagement(dashboardModel) &&
                dashboardModel.getProp('source') === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                orderByProperty = _.get(aggregatePaidToOrganicProperty, [orderByProperty], orderByProperty);
            }

            const orderBy = {
                property: orderByProperty,
                dimensions: ['channel', 'post'],
                channel: dashboardModel.getProp('channel')
            };

            let metricValue;
            let metricName;
            if (orderBy.property === 'published_at') {
                const dateInTz = RivalIQ.utils.timezone.getDateInTimezone(me.dashboardModel.getProp('timezone'), me.model.get(orderBy.property));
                const tzPart = RivalIQ.utils.timezone.getTimezoneAbbreviation(me.dashboardModel.getProp('timezone'), dateInTz);
                metricValue = [dateInTz.format('MMM D, YYYY LT'), tzPart].join(' ');
            } else if (orderBy.property === 'media_type') {
                metricValue = RivalIQ.metric.format.formatFn(orderBy)(me.model.get(orderBy.property));
            } else if (orderBy.property === 'story_day_date') {
                metricValue = formatStoryDate(me.model.get('story_day_date'), me.dashboardModel.getProp('timezone'));
            } else if (orderBy.property === 'num_stories') {
                const numStories = me.model.get(orderBy.property);
                metricValue = numStories;
                metricName = RivalIQ.formatter.numericLabel('story', 'stories', numStories);
            } else if (orderBy.property === 'order_details') {
                const orderDetails = me.model.get(orderBy.property);
                metricValue = makeOrderDetailsStr(orderDetails);
            } else if (orderBy.property === 'boosted_post_total_spend') {
                const paidSpend = me.model.get('paid_spend');
                metricValue = App.utils.currencyTemplateHelpers(dashboardModel).currency(paidSpend);
                metricName = RivalIQ.metric.names.metricName(orderBy);
            } else {
                const value = me.model.get(orderBy.property);
                metricValue = RivalIQ.formatter.falsyDataWrapper(RivalIQ.metric.format.formatFn(orderBy))(value);
                metricName = RivalIQ.metric.names.metricName(orderBy);
            }

            return {
                metricValue: metricValue,
                metricName: metricName || null
            };
        },

        getMetricName: function () {
            const me = this;
            return me.getGridDetailMetric().metricName;
        },

        onRender: function () {
            const me = this;
            me.ui.popover.popover({
                html: true
            });

            me.ui.tooltips.tooltip();
        }
    });

    media.InstagramStoriesGridItem = BaseGridItem.extend({
        template: '#instagramStoryGridItemTemplate',

        serializeData: function () {
            const me = this;
            const model = me.model;
            const data = model.toJSON();

            let orderDetailsStr = '';
            if (data.order_details) {
                orderDetailsStr = makeOrderDetailsStr(data.order_details);
            }

            return _.extend({
                maxMessageLength: media.utils.MAX_BODY_LENGTH,
                textOnlyMode: false,
                isSquare: RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me),
                metric: me.getGridDetailMetric(),
                publishedAtDate: formatPublishedAt(data.published_at, me.dashboardModel.getProp('timezone')),
                orderDetailsStr: orderDetailsStr
            }, data);
        },

        onClick: function () {
            const me = this;
            App.widgets.media.utils.showDetails(me.dashboardModel, me.model.toJSON(), me.getOption('metric'), null);
        }
    });

    media.InstagramStoryDaysGridItem = BaseGridItem.extend({
        template: '#instagramStoryDayGridItemTemplate',

        serializeData: function () {
            const me = this;
            const data = me.model.toJSON();

            return _.extend({
                maxMessageLength: media.utils.MAX_BODY_LENGTH,
                textOnlyMode: false,
                isSquare: RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me),
                metric: me.getGridDetailMetric(),
                storyDate: formatStoryDate(data.story_day_date, me.dashboardModel.getProp('timezone'))
            }, data);
        },

        onClick: function () {
            const me = this;

            const storyDay = me.model.get('story_day_date');
            App.widgets.media.utils.navToStoryDay(me.dashboardModel, storyDay);
        }
    });

    media.InsightsPostGridItem = BaseGridItem.extend({
        template: '#insightsPostGridItemTemplate',

        templateHelpers: function () {
            const me = this;
            return _.defaults(App.utils.currencyTemplateHelpers(me.dashboardModel), BaseGridItem.prototype.templateHelpers.apply(me, arguments));
        },

        regions: {
            postTagPillsContainer: '.post-tag-pills'
        },

        attributes: function () {
            const me = this;

            const attributes = BaseGridItem.prototype.attributes.apply(me, arguments);
            if (RivalIQ.apps.SocialPosts.utils.isGridLayout(me)) {
                const modelJson = me.model.toJSON();
                const source = modelJson.source;
                if (source === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
                    const id = me.model.get('facebook_post_id');
                    attributes['data-post-id'] = `${RivalIQ.enums.sources.FACEBOOK}.${id}`;
                }
            }

            return attributes;
        },

        serializeData: function () {
            const me = this;
            const model = me.model;
            const data = model.toJSON();

            const channelName = RivalIQ.data.channels.getPlatformName(data.source);

            let videoSrc = null;
            if (App.widgets.media.utils.useLinkedInMp4(data)) {
                videoSrc = data.media_url;
            }
            const textOnlyMode = !data.image || data.imageInvalid;

            let postId;
            if (data.source === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
                postId = `${RivalIQ.enums.sources.FACEBOOK}.${data.facebook_post_id}`;
            } else {
                postId = `${data.source}.${data.id}`;
            }

            data.image ||= data.platformImageUrl;

            return _.extend({
                channelName: channelName,
                videoSrc: videoSrc,
                useCdnThumbnail: _.get(data, 'useCdnThumbnail', false),
                isSquare: RivalIQ.apps.SocialPosts.utils.isGridSquareLayout(me),
                maxMessageLength: media.utils.MAX_BODY_LENGTH,
                textOnlyMode: textOnlyMode,
                metric: me.getGridDetailMetric(),
                paid_spend: null,
                publishedAtDate: formatPublishedAt(data.published_at, me.dashboardModel.getProp('timezone')),
                postId: postId,
                last_pull_attempt_at: data.captured_at || null
            }, data);
        },

        onClick: function (e) {
            const me = this;

            const $target = $(e.target);

            // Links and post tag inline adder should not pop the modal
            if ($target.is('a') || me.getProp('noClickThrough') || $target.hasClass('post-tag-action-btn') || $target.parents('.post-tag-action-btn').length) {
                e.stopPropagation();
                return;
            }

            App.widgets.media.utils.showDetails(me.dashboardModel, me.model.toJSON(), me.getOption('metric'), me.options.postTagsById);
        },

        onRender: function () {
            const me = this;

            me.postTagPills = new RivalIQ.apps.SocialPosts.views.PostTagPills({
                post: me.model,
                postTagsById: _.get(me, ['options', 'postTagsById']) || {},
                parentDashboardModel: me.dashboardModel,
                postTagsClickable: false,
                showActionBtns: !me.dashboardModel.isExporting()
            });

            me.postTagPillsContainer.show(me.postTagPills);
        }
    });


}, window.s, window.moment);
